module.exports = __webpack_public_path__ + "img/josephgunnar.7b894de5.png";